import { useTranslation } from 'react-i18next';
import { AppContext } from '../../services/AppContext';
import { React, useState, useContext, useEffect } from 'react';
import MultiSelector from '../../components/global/MultiSelector';

const SubscriptionPresetEditor = ({ closeModal, subscriptionPreset }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const [newSubscriptionPreset, setNewSubscriptionPreset] = useState({
        id: subscriptionPreset?.id,
        name: subscriptionPreset?.name || '',
        total: subscriptionPreset?.total || '',
        cost: subscriptionPreset?.cost || ''
    });
    const [tagData, setTagData] = useState([]);
    const [selectedTags, setSelectedTags] = useState(subscriptionPreset?.tags.map(t => t.id) || []);
    const updating = !!subscriptionPreset;

    const handleSaveSubscriptionPreset = async () => {
        newSubscriptionPreset.tags = selectedTags;

        if (!updating) {
            delete newSubscriptionPreset.id;
        }

        const result = updating
            ? await apiClient.updateSubscriptionPreset(newSubscriptionPreset)
            : await apiClient.createSubscriptionPreset(newSubscriptionPreset);

        if (result.hasErrors) {
            return;
        }

        closeModal(true);

        notify(
            t(`pages.subscriptionPresets.notifications.${updating ? 'updated' : 'created'}`),
            'success'
        );
        setNewSubscriptionPreset({});
    };

    const handleCancel = () => {
        setNewSubscriptionPreset({});
        closeModal(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewSubscriptionPreset((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const fetchData = async () => {
        const data = await apiClient.getTags();

        if (!data.hasErrors) {
            setTagData(data);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="modal">
            <div className="modal-content">
                <h3>
                    {updating
                        ? t('pages.subscriptionPresets.headers.update')
                        : t('pages.subscriptionPresets.headers.new')}
                </h3>
                <input
                    type="text"
                    name="name"
                    placeholder={t('pages.subscriptionPresets.placeholders.name')}
                    value={newSubscriptionPreset.name}
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="total"
                    placeholder={t('pages.subscriptionPresets.placeholders.total')}
                    value={newSubscriptionPreset.total}
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="cost"
                    placeholder={t('pages.subscriptionPresets.placeholders.cost')}
                    value={newSubscriptionPreset.cost}
                    onChange={handleChange}
                />

                <div className="mg-b-1">
                    <MultiSelector
                        options={tagData}
                        selection={selectedTags}
                        onChange={(selection) => setSelectedTags(selection)}
                    />
                </div>

                <div className="container">
                    <button className="mg-r-1 width-100p" onClick={handleSaveSubscriptionPreset}>
                        {t('pages.subscriptionPresets.actions.save')}
                    </button>
                    <button className="width-100p" onClick={handleCancel}>
                        {t('pages.subscriptionPresets.actions.cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPresetEditor;